import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, IComboPaises } from './types';

export const INITIAL_STATE: IComboPaises = {
	status: 0,
	data: {
		processoId: '0',
		paises: [],
	},
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IComboPaises {
	return produce(state, draft => {
		switch (action.type) {
			case Types.COMBO_PAISES_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.COMBO_PAISES_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.COMBO_PAISES_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
